import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { LinkButton } from "@app/components/common/link-button/LinkButton";
import {
  LinkButtonType,
  ButtonSize,
  ButtonVariant,
} from "@app/components/common/enums";
import { useGenericData } from "@app/hooks/use-generic-data/useGenericData";
import { INavigationMenuItem } from "@app/models/storyblok/datasource";
import { Menu } from "./components/menu/Menu";
import { LanguageSwitcher } from "./components/language-switcher/LanguageSwitcher";

type Props = {
  data: INavigationMenuItem[];
  isOpen: boolean;
  onClose: () => void;
};

export const MobileNavigation: FC<Props> = ({ data, isOpen, onClose }) => {
  const { t } = useTranslation("mainnav");
  const { notificationBar } = useGenericData();
  const isNotificationBarEnabled = notificationBar?.isEnabled;

  return (
    <nav
      className={classNames(
        "fixed bottom-4 left-4 right-4 z-[900] flex flex-col justify-between rounded-2xl bg-nav bg-opacity-[88%] pb-6 pt-7 text-base-content backdrop-blur-md",
        "lg:bottom-7.5 lg:left-7.5 lg:right-7.5",
        {
          invisible: !isOpen,
          "top-[9.5rem] lg:top-44": isNotificationBarEnabled,
          "top-27 lg:top-[8.5rem]": !isNotificationBarEnabled,
        },
      )}
    >
      <Menu {...{ data, onClose }} />

      <div className="shrink-0 px-5">
        <LanguageSwitcher />
        <LinkButton
          to=""
          label={t("cta")}
          type={LinkButtonType.DOWNLOAD_APP}
          variant={ButtonVariant.FILL_PRIMARY_CONTENT}
          size={ButtonSize.STANDART}
          isFullWidth
        />
      </div>
    </nav>
  );
};
